import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '@/views/Home.vue';
import Calendar from '@/views/Calendar.vue';
import Consul from '@/views/Consul.vue';
import ProtectedPage from '@/views/ProtectedPage.vue';

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/secret/calendar',
    name: 'calendar',
    component: Calendar
  },
  {
    path: '/consul',
    name: 'consul',
    component: Consul,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/consul/*',
    redirect: '/consul'
  },
  {
    path: '/protected',
    name: 'protected',
    component: ProtectedPage,
  },
  // {
  //   path: '/*',
  //   redirect: '/'
  // }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

const COOKIE = 'authorized';
const CONSUL_PASSWORD = process.env.VUE_APP_CONSUL_PW;

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    if (localStorage.getItem(COOKIE) !== CONSUL_PASSWORD) next('/protected');
    else next();
  } else next();
})

export default router;
